import { GridColumnType } from "../../../data/gridColumnType";


import { validationTypes } from "../../../components/FinalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../data/formFieldType";

const initState = {
  skillCategoriesName: "",
  description: ""
};

const SkillCategoryDataFields = {
  name: "Add Skill Category",
  initialState: initState,
  section: [
    {
      title: "Add Skill Category Section",
      row: {},
      style: {
        sectionStyle: "row",
      },
      fields: [
        {
          id: "skillCategoriesName",
          label: "Skill Category Name",
          Field_Name: "Skill Category Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "skillCategoriesName",
          fieldSetting: {
            placeholder: "Please Enter Skill Category Name",
            // isMultiSelect: true,
            options: [],
            maxLength: 50,
          },
          changeAction: {
            resetValue: [
              {
                dataField: "skillCategoriesName",
                value: null
              }
            ]
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },
        {
          id: "description",
          label: "Description",
          Field_Name: "Description",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "description",
          fieldSetting: {
            placeholder: "Enter Description",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-12 mb-2",
          },
        },

      ],
    }
  ],
  formSetting: {
    isViewOnly: false,
}
};

export default SkillCategoryDataFields;
//** Table columns configuration */
export const SkillCategoryListGridConfig = {
    columns: [
        {
            name: "Skill Category Name",
            fieldName: "skillCategoriesName",
            allowShort: false,
        },
        {
          name : "Description",
          fieldName : "description",
          allowShort: false,
        },
        {
            name: "Created Date",
            fieldName: "createdAt",
            colType: GridColumnType.DATE,
            colSettings: {
              isUTC: true,
              format: "DD/MM/YYYY hh:mm A ",
            },
            allowShort: false,
        },
        {
          name : "CreatedBy",
          fieldName : "fullName",
          allowShort: false,
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
              allowEdit: true,
              allowDelete: true,
          }
        },
    ],
}

